
function importAll(r) {
    return r.keys().map(r);
}

const images = importAll(
    require.context("./01_images", false, /\.png$/)
);

export const cardImages = images.map(image => image)

